import { render, staticRenderFns } from "./WaterIcon.vue?vue&type=template&id=7606c4e7&"
import script from "./WaterIcon.vue?vue&type=script&lang=js&"
export * from "./WaterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports